import * as React from 'react';
import {
    OverlayFormInput,
    Button
} from 'components';
import { actions as appActions } from 'services/app/app-service';
import { useTranslation } from 'react-i18next';

import './login-form.scss';
import { useSelector } from 'react-redux';
import { getOperationSafe } from 'selectors';
import { IState } from 'services/root-reducer';
import { EOperationStatus } from 'types';

export const LoginForm = () => {
    const [ login, setLogin ] = React.useState<string>('');
    const [ password, setPassword ] = React.useState<string>('');

    const [ loginError, setLoginError ] = React.useState<string>('');
    const [ passowrdError, setPasswordError ] = React.useState<string>('');

    const loginOperation = useSelector((state: IState) => getOperationSafe(state, 'LOGIN'));
    const operationInProgress = loginOperation.status === EOperationStatus.PENDING;
    const { t } = useTranslation();

    const validateForm = (): boolean => {
        if (login.length <= 0) {
            setLoginError(t('Поле обязательно для заполнения'));
        }

        if (password.length <= 0) {
            setPasswordError(t('Поле обязательно для заполнения'));
        }

        return (
            login.length <= 0
            || password.length <= 0
        );
    };

    const onLoginChange = (value: string) => {
        setLogin(value);
        setLoginError('');
    };
    const onPasswordChange = (value: string) => {
        setPassword(value);
        setPasswordError('');
    };

    return (
        <div className="login-form-wrapper">
            <OverlayFormInput
                disabled={operationInProgress}
                variant='underlined'
                placeholder={t('Логин')}
                value={login}
                error={loginError}
                onChange={onLoginChange}
            />

            <OverlayFormInput
                disabled={operationInProgress}
                variant='underlined'
                type='password'
                placeholder={t('Пароль')}
                value={password}
                error={passowrdError}
                onChange={onPasswordChange}
            />

            {loginOperation.status === EOperationStatus.FAIL && (
                <div className="login-errors">
                    {t('Ошибка авторизации')}
                </div>
            )}

            <div className="login-form-buttons">
                <Button
                    text={t('Войти')}
                    disabled={operationInProgress}
                    onClick={() => {
                        let formHasErrors = validateForm();
                        if (!formHasErrors) {
                            appActions.login({ login, password });
                        }
                    }}
                />
            </div>
        </div>
    );
};
